const state = {
    CONNECTED: 'dcent-connected',
    DISCONNECTED: 'dcent-disconnected',
}

module.exports = {
    state,
}
